<template>
  <el-dialog title="详情" v-model="isDetail" width="40%" center>
    <div class="page_warp scroll-view">
      <div class="input_row">
        <div class="input_lable">序号：</div>
        <div class="input_box">
          <el-input
            v-model="dataItem.roleName"
            disabled
            placeholder="请输入"
          ></el-input>
        </div>
      </div>

      <div class="input_row">
        <div class="input_lable">账号：</div>
        <div class="input_box">
          <el-input
            v-model="dataItem.userLgname"
            disabled
            placeholder="请输入"
          ></el-input>
        </div>
      </div>

      <div class="input_row">
        <div class="input_lable">用户名：</div>
        <div class="input_box">
          <el-input
            v-model="dataItem.logUserName"
            disabled
            placeholder="请输入"
          ></el-input>
        </div>
      </div>

      <div class="input_row">
        <div class="input_lable">操作内容：</div>
        <div class="input_box">
          <el-input
            v-model="dataItem.logOper"
            disabled
            placeholder="请输入"
          ></el-input>
        </div>
      </div>

      <div class="input_row">
        <div class="input_lable">操作用时：</div>
        <div class="input_box">
          <el-input
            v-model="dataItem.logRespTime"
            disabled
            placeholder="请输入"
          ></el-input>
        </div>
      </div>

      <div class="input_row">
        <div class="input_lable">方法：</div>
        <div class="input_box">
          <el-input
            v-model="dataItem.logMethod"
            disabled
            placeholder="请输入"
          ></el-input>
        </div>
      </div>

      <div class="input_row">
        <div class="input_lable">参数：</div>
        <div class="input_box">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 8 }"
            resize="none"
            readonly
            v-model="dataItem.logParam"
          ></el-input>
        </div>
      </div>

      <div class="input_row">
        <div class="input_lable">IP地址：</div>
        <div class="input_box">
          <el-input
            v-model="dataItem.logIp"
            disabled
            placeholder="请输入"
          ></el-input>
        </div>
      </div>

      <div class="input_row">
        <div class="input_lable">创建时间：</div>
        <div class="input_box">
          <el-input
            v-model="dataItem.logCreTime"
            disabled
            placeholder="请输入"
          ></el-input>
        </div>
      </div>

      <div class="footer_btn_warp">
        <div class="cancle_btn" @click="closeModal()">关闭</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  defineComponent,
  reactive,
  toRefs,
  getCurrentInstance,
  onMounted,
  nextTick,
} from "vue";
import { imgFileToBase64, isChinese } from "@/libs/tools";
import { useStore } from "vuex";
import { apiObj } from "@/config/api";
export default defineComponent({
  name: "Detail",

  emits: ["getData"],
  setup(props, context) {
    const store = useStore();
    const { proxy } = getCurrentInstance();

    onMounted(() => {});
    const data = reactive({
      isDetail: false,

      dataItem: {
        logId: "",
        logUserId: "",
        logUserName: "",
        logOper: "",
        logRespTime: "",
        logMethod: "",
        logParam: "",
        logIp: "",
        logCreTime: "",
        userLgname: "",
      },
    });
    //重置数据
    const init = async (id) => {
      data.isDetail = true;
      getDetail(id);
    };
    //详情
    const getDetail = async (id) => {
      let params = {
        logId: id,
      };
      const r = await proxy.$http.post(apiObj.logDetail, params);
      if (r) {
        data.dataItem.logId = r.logId;
        data.dataItem.logUserId = r.logUserId;
        data.dataItem.logUserName = r.logUserName;
        data.dataItem.logOper = r.logOper;
        data.dataItem.logRespTime = r.logRespTime + "ms";
        data.dataItem.logMethod = r.logMethod;
        data.dataItem.logParam = r.logParam;
        data.dataItem.logIp = r.logIp;
        data.dataItem.logCreTime = r.logCreTime;
        data.dataItem.userLgname = r.userLgname;
      }
    };
    const closeModal = () => {
      data.isDetail = false;
    };

    return {
      ...toRefs(data),
      init,
      getDetail,
      closeModal,
    };
  },
});
</script>
<style scoped>
.page_warp {
  width: 100%;
  max-height: 600px;
}
.input_row {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
}
.input_lable {
  width: 80px;
  text-align: right;
}
.input_box {
  width: 70%;
}
.input_tree_warp {
  width: calc(100% - 30px);
  height: 300px;
  margin-left: 30px;

  box-sizing: border-box;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.manage {
  width: 48%;
  height: 100%;

  display: flex;
}
.tree {
  width: calc(100% - 80px);
  height: 100%;
  overflow: auto;
}
.footer_btn_warp {
  width: 100%;
  height: 70px;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cancle_btn {
  width: 116px;
  height: 38px;
  background: #e36a19;
  border-radius: 4px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 38px;
  cursor: pointer;
}
.confirm_btn {
  width: 116px;
  height: 38px;
  background: #293787;
  border-radius: 4px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 38px;
  cursor: pointer;
}
</style>
